<template>
  <div class="container__menuoptions">
    <i
      class="fas fa-bars container__menuoptions__hamburguer"
      @click="changeIsMenuHamburguerActive();
            cleanActiveSubmenuActive();"
    ></i>
    <img
      class="container__menuoptions__logo"
      src="../../../assets/treevia-logo.png"
    />
    <MenuNavigation
      :menuOptions="menuOptions"
      :isMenuHamburguerActive="isMenuHamburguerActive"
      :cleanActiveSubmenuActive="cleanActiveSubmenuActive"
    />
    <Backdrop
      :isBackdropActivated="isMenuHamburguerActive"
      :clickOptionalEvent="changeIsMenuHamburguerActive"
    />

    <Button
      :widthAuto="true"
      semanticClass="mini"
      label="Sair"
      type="submit"
      :disabled="disabledLoginButton"
      @click="SignOut"
    />
  </div>
</template>

<script>
import Button from "../../../components/Button/Button";
import { PublicClientApplication } from "@azure/msal-browser";

import Backdrop from "../../Backdrop/Backdrop";
import MenuNavigation from "../MenuNavigation/MenuNavigation";

export default {
  components: { Backdrop, MenuNavigation, Button },
  data() {
    return {
      /**
       * Opções do menu que deverão estar no navigation
       */
      account: undefined,
      disabledLoginButton: false,

      menuOptions: [
        {
          menuItem: "Home",
          subItens: [{ name: "Dashboard", link: "dashboard" }],
          subMenuActive: false,
        },

        {
          menuItem: "Cadastros",
          subItens: [
            { name: "Version", link: "version" },
            { name: "Production", link: "production" },
            { name: "Operation", link: "operation" },
          ],
          subMenuActive: false,
        },
        {
          menuItem: "Clientes",
          subItens: [{ name: "Clientes", link: "customer" }],
          subMenuActive: false,
        },
        {
          menuItem: "Docs",
          subItens: [{ name: "Trv Docs", link: "trvdocsdevice" }],
          subMenuActive: false,
        },
        {
          menuItem: "Dump",
          subItens: [{ name: "Dump", link: "dump" }],
          subMenuActive: false,
        },
        {
          menuItem: "Exportações",
          subItens: [{ name: "Exportações em CSV", link: "exportsCSV" }],
          subMenuActive: false,
        },
        { menuItem:"Virada de Cadastro",
          subItens: [ {name:"Virada de Cadastro", link:"viradaCadastro"} ],
          subMenuActive: false,

        },
        {
          menuItem: "SingleTrees",
          subItens: [
            { name: "Exportação Estimativa", link: "singletreesexportacao" },
            { name: "Upload Info Amostra", link: "singletreesupload" },
            { name: "Reprocessamento", link: "singletreesreprocessamento" },
            { name: "Deleção de Coletas", link: "singletreesdelecao" },
          ],
          subMenuActive: false,
        }
      ],
      isMenuHamburguerActive: false,
    };
  },
  async created() {
    window.addEventListener("resize", this.handleWhenResize);

    this.$msalInstance = new PublicClientApplication(
      this.$store.state.moduleLogin.msalConfig
    );
    // MSAL v3 exige initialize() antes de qualquer chamada (logout incluso)
    await this.$msalInstance.initialize();
  },
  mounted() {
    const accounts = this.$msalInstance.getAllAccounts();
    if (accounts.length == 0) {
      return;
    }
    this.account = accounts[0];
    this.$emitter.emit("login", this.account);
  },

  methods: {
    async SignOut() {
      this.disabledLoginButton = true;

      // o jwt das APIs sai antes do redirect — sem ele o guard não deixa voltar
      localStorage.removeItem("jwt");
      this.$emitter.emit("logout", "logging out");

      try {
        await this.$msalInstance.initialize();
        await this.$msalInstance.logoutPopup({
          account: this.account,
          mainWindowRedirectUri: "/",
        });
      } catch (error) {
        console.error(error);
        // mesmo se o MSAL falhar (ex.: popup bloqueado), derruba a sessão local
        localStorage.clear();
        this.$router.push({ name: "Login" });
      } finally {
        this.disabledLoginButton = false;
      }
    },

    /**
     * Deixa todos os submenus desativados
     */
    cleanActiveSubmenuActive() {
      this.menuOptions.forEach((item) => {
        item.subMenuActive = false;
      });
    },
    /**
     * Muda a condicao de quando o menu lateral está ou nao aberto
     */
    changeIsMenuHamburguerActive() {
      this.isMenuHamburguerActive = !this.isMenuHamburguerActive;
    },
    /**
     * Trocar variavel que controla o menu hamburguer para false quando o tamanho
     * da tela nao for para mobile
     */
    handleWhenResize() {
      if (window.innerWidth > 992) {
        this.isMenuHamburguerActive = false;
        this.cleanActiveSubmenuActive();
      }
    },
  },
  unmounted() {
    window.removeEventListener("resize", this.handleWhenResize);
  },
};
</script>

<style scoped>
.container__menuoptions {
  display: flex;
  align-items: center;
}

.container__menuoptions__logo {
  display: none;
}

@media screen and (min-width: 992px) {
  .container__menuoptions {
    width: 100%;
    height: 100%;
  }
  .container__menuoptions__hamburguer {
    display: none;
  }

  .container__menuoptions__logo {
    display: block;
    width: 27px;
    height: 20px;
  }
}
.ui.button {
  margin-top: 5px;
}
</style>